"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const PaymentDetails_1 = require("./PaymentDetails");
const UpdateActions_1 = require("./enums/UpdateActions");
class AcceptQuotation extends base_models_1.Serializable {
}
exports.default = AcceptQuotation;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'action' }),
    (0, base_models_1.Docs)({
        description: 'what BPM action to take',
        example: UpdateActions_1.UpdateActions.SubmitQuotationApproval,
    }),
    (0, class_validator_1.IsIn)([
        UpdateActions_1.UpdateActions.SubmitQuotationApproval,
        UpdateActions_1.UpdateActions.SubmitQuotationRejected,
        UpdateActions_1.UpdateActions.ApproveDriverQuotation,
        UpdateActions_1.UpdateActions.RejectDriverQuotation,
    ]),
    tslib_1.__metadata("design:type", String)
], AcceptQuotation.prototype, "action", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => PaymentDetails_1.LeadFormPaymentDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {},
        description: 'payment details',
    }),
    (0, class_transformer_1.Expose)({ name: 'payment_details' }),
    tslib_1.__metadata("design:type", PaymentDetails_1.LeadFormPaymentDetails)
], AcceptQuotation.prototype, "paymentDetails", void 0);
